(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-neelofa-video"] && !Shopify.designMode) return;
  try {
    
  /*
   * Tap to unmute for the self hosted video (change item 3).
   *
   * Shopify concatenates every section's javascript into one theme-wide bundle that runs on every
   * page, so this is an IIFE and everything hangs off the custom element. With no
   * <mh-neelofa-video> in the document, nothing here does anything.
   *
   * The video is muted in the markup because that is the only state a browser will autoplay. The
   * button is rendered `hidden` and revealed here, so with scripting off there is no control that
   * cannot work; the native controls are on the video either way.
   */
  (function () {
    class MhNeelofaVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-mh-unmute]');
        if (!this.video || !this.button) return;

        // Only offer the control while there is something to undo.
        this.button.hidden = !this.video.muted;

        this.button.addEventListener('click', () => {
          this.video.muted = false;

          // Autoplay may have been refused outright, in which case the tap that unmuted is also
          // the gesture that is allowed to start playback.
          const attempt = this.video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        });

        // Keeps the button honest when the sound is changed from the native controls instead.
        this.video.addEventListener('volumechange', () => {
          this.button.hidden = !this.video.muted;
        });
      }
    }

    if (!customElements.get('mh-neelofa-video')) {
      customElements.define('mh-neelofa-video', MhNeelofaVideo);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
